/** @jsx jsx */

import "./NavHeader.css"
import { jsx, Flex, Text, IconButton } from "theme-ui"
import { useState, useEffect } from "react"
import { navigate } from "gatsby"

import { Link } from "./Link"
import PropTypes from "prop-types"

const PaginationButton = ({ direction, currentPage }) => {
  if (direction === "prev") {
    return (
      <IconButton onClick={() => navigate(`/${currentPage - 1}`)}>
        <svg height="32" width="32" fill="white">
          <polygon points="3.6,16 18,24 18,8" />
        </svg>
      </IconButton>
    )
  } else {
    return (
      <IconButton onClick={() => navigate(`/${currentPage + 1}`)}>
        <svg height="32" width="32" fill="white">
          <polygon points="8,24 8,8 22.4,16" />
        </svg>
      </IconButton>
    )
  }
}
PaginationButton.propTypes = {
  direction: PropTypes.oneOf(["prev", "next"]),
  currentPage: PropTypes.number,
}

const Pagination = ({ currentPage }) => (
  <Flex
    sx={{
      color: "white",
      alignItems: "center",
      justifyContent: ["flex-end", "center"],
      height: "50px",
      p: 2
    }}
  >
    {currentPage > 1 ? <PaginationButton direction="prev" currentPage={currentPage}/> : null}
    <Text sx={{ mx: 2}}>{currentPage}</Text>
    {currentPage < process.env.GATSBY_TOTAL_PAGES ? (
      <PaginationButton direction="next" currentPage={currentPage}/>
    ) : null}
  </Flex>
)
Pagination.propTypes = {
  currentPage: PropTypes.number,
}

export const NavHeader = ({ currentPage}) => {
  const [show, setShow] = useState(true)
  const controlVisibility = () => {
    if (window.scrollY > 100) {
      setShow(false)
    } else {
      setShow(true)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", controlVisibility)
    return () => {
      window.removeEventListener("scroll", controlVisibility)
    }
  }, [])

  return (
    <div
      onMouseEnter={() => setShow(true)}
      className={show ? "nav__visible" : null}
      sx={{
        position: "sticky",
        top: 0,
        height: "50px",
        zIndex: 1,
        width: "100%",
        background: "primary",
        transitionTimingFunction: "ease-in",
        transition: "0.5s",
        opacity: [0, "1 !important", 0],
      }}
    >
      <Link variant="primary" to="/" sx={{ position: "absolute", left: 10 }}>
        <h1 sx={{ color: "white", fontSize: 2, my: "10px" }}>Refu(SAL/SE/GE)</h1>
      </Link>
      {currentPage ? <Pagination currentPage={currentPage} /> : null}
      <Link variant="primary" to="https://refusejournal.com/" sx={{ position: "absolute", right: 20, top: 0}}>
        <h2 sx={{ color: "#cccccc", fontSize: 1, my: "10px" }}>REFUSE: A Journal of Iconoclasms</h2>
      </Link>
    </div>
  )
}

NavHeader.propTypes = {
  currentPage: PropTypes.number,
}
